<template src="@/templates/reports/outstandingInvoices.html"></template>

<script>
    import OutstandingInvoicesCollection from "@/collections/outstandingInvoicesCollection";
    import moment from 'moment';
    import {authorizationService} from '../../authorization/authorizationService';

    export default {
        name: 'OutstandingInvoices',
        created() {
            let self = this;
            authorizationService.authorize("/DownloadInvoices").then(res => {
                self.canDownloadInvoices = res.data.result === 1;
            }).catch(err => {
                console.log(err);
            });
            if (localStorage.getItem("pageSize") != null) {
                this.pageSize = parseInt(localStorage.getItem("pageSize"));
            } else {
                localStorage.setItem("pageSize", this.pageSize.toString());
            }

            this.loadOutstandingInvoices();
        },
        data() {
            return {
                outstandingInvoicesCollection: new OutstandingInvoicesCollection,
                countOutstandingInvoice: false,
                totalPage: 0,
                currentPage: 1,
                totalRecordsLabel: 0,
                recordFrom: 0,
                recordTo: 0,
                pageSize: 50,
                canDownloadInvoices: false,
                paginationOptions: [
                    {
                        value: 0,
                        label: 'All'
                    },
                    {
                        value: 5,
                        label: '5'
                    },
                    {
                        value: 10,
                        label: '10'
                    },
                    {
                        value: 15,
                        label: '15'
                    },
                    {
                        value: 20,
                        label: '20'
                    },
                    {
                        value: 50,
                        label: '50'
                    },
                    {
                        value: 100,
                        label: '100'
                    }
                ],
            }
        },
        methods: {
            loadOutstandingInvoices: function (clearPager) {
                if (clearPager) {
                    this.totalPage = 0;
                    this.currentPage = 1;
                }

                let url = this.$localApiURL + this.outstandingInvoicesCollection.getRoute("fetch") + "?count=" + this.countOutstandingInvoice + "&token=" + localStorage.getItem('jwt');
                this.$http.post(url, {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                }).then((response) => {
                    if (response.data !== null && response.data !== {}) {
                        let result = response.data;
                        this.totalRecordsLabel = parseInt(result.totalInvoices ? result.totalInvoices : "0");
                        if (this.pageSize === 0) {
                            this.totalPage = 0;
                            this.recordFrom = 1;
                            this.recordTo = this.totalRecordsLabel;
                        } else {
                            this.totalPage = this.totalRecordsLabel;
                        }
                        let pageSizeEnd = (this.pageSize * this.currentPage);
                        this.outstandingInvoicesCollection.models = response.data.data;
                        this.recordFrom = this.totalRecordsLabel === 0 ? this.totalRecordsLabel : (this.pageSize * (this.currentPage - 1)) + 1;
                        this.recordTo = pageSizeEnd >= this.totalRecordsLabel || pageSizeEnd === 0 ? this.totalRecordsLabel : pageSizeEnd;
                    } else {
                        this.totalPage = 0;
                        this.outstandingInvoicesCollection.models = [];
                    }
                }).catch((error) => {
                    console.error(error);
                });
            },
            overdueCalculation(model) {
                let dueDate = moment(model.invoice_date).add(model.pay_within, 'd');
                let current = moment().startOf('day');
                let overdue = current.diff(dueDate, 'days');

                if (overdue > 0) {
                    model.overdueText = "Please Pay";
                    return overdue;
                }
                else {
                    return 0
                }
            },
            downloadInvoice(invoiceNumber) {

                let url = this.$localApiURL + this.outstandingInvoicesCollection.getRoute("post");
                url = url + "/" + invoiceNumber + "?token=" + localStorage.getItem("jwt");
                location.href = url;

            },
            handleSizeChange(val) {
                localStorage.setItem("pageSize", val);
                this.loadOutstandingInvoices(true);
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.loadOutstandingInvoices(false);
            }
        }
    }
</script>

<style lang="scss">

    @import '../../assets/scss/general.scss';

    .scrollable {
        $bodyHeader: 20px;
        $tableHeader: 58px;
        $pagination: 50px;
        $bottomGap: 0px;

        /*
            Use Interpolation
            #{$bodyTopMargin}
        */
        $total: calc(#{$navHeader} +
        #{$bodyTopMargin} +
        #{$bodyHeader} +
        #{$tableHeader} +
        #{$pagination} +
        #{$bottomGap} +
        #{$footer});

        height: calc(100vh - #{$total});
        overflow-y: scroll;
        background: #fff;
    }

    .myPagination-group {

        > div {
            padding: 1px 5px;
            color: $myColor-gray-text;

            b {
                color: $myColor-primary;
            }
        }

        .el-input__inner {
            height: 35px !important;
        }

        .myPagination {

            /* Font*/
            li {
                padding-top: 3px;
                font-size: 16px;
                font-weight: normal;
            }

            /* Element Size and the Border */
            li, button {
                margin: 0 !important;
                border: 1px solid $myColor-blue-header;
                border-radius: 0 !important;
                width: 45px !important;
                height: 35px !important;
                align-items: center;

                &:not(:disabled):hover {
                    background: rgba($myColor-primary, .8) !important;
                    color: #fff !important;
                }

                &:not(:disabled).active {
                    background: $myColor-primary !important;
                    color: #fff;
                    border-bottom: 3px solid $myColor-secondary;
                }
            }
        }
    }

    // *** PAGINATION


</style>



// WEBPACK FOOTER //
// src/components/reports/OutstandingInvoicesComponent.vue